class speakerPairing extends HTMLElement {
  /** Bypass :root { scroll-behavior: smooth } (theme-style.liquid) for programmatic restores (e.g. placement tabs) */
  static _scrollWindowInstant(y) {
    const top = Math.max(0, Math.round(Number(y) || 0));
    window.scrollTo({ top, left: 0, behavior: 'instant' });
    if (document.documentElement) document.documentElement.scrollTop = top;
    if (document.body) document.body.scrollTop = top;
  }

  constructor() {
    super();

    this.initBtn = document.querySelectorAll('a[href="#speaker-pairing"]');
    this.stepsInit = this.querySelector('[data-speaker-pairing-setup]');
    this.resultsEle = this.querySelector('[data-speaker-pairing-result]');

    this.allProducts = JSON.parse(this.querySelector('[data-all-products-json]').textContent);
    this.tabArticles = JSON.parse(this.querySelector('[data-tabs-articles]').textContent);

    this.stepTrigger = this.querySelectorAll('[data-step-trigger]');
    this.stepEles = this.querySelectorAll('.steps-wrapper .step');
    this.brandsJson = this.querySelector('[data-brand-model-json]');

    this.step1Selectors = {
      brand: this.querySelector('[data-speaker-brand]'),
      model: this.querySelector('[data-speaker-model]')
    }
    this.step2Selectors = {
      preheadingEle: this.querySelector('.step-2 [data-selected-brand-data]'),
      intendedUse: this.querySelectorAll('.step-2 input[name="intended_use"]')
    }

    this.step3Selectors = {
      preheadingEle: this.querySelector('.step-3 [data-selected-brand-data]'),
      preheadingEleIntendedUse: this.querySelector('.step-3 [data-selected-intended-use-data]'),
      roomSizeRadio: this.querySelectorAll('.step-3 input[name="room_size"]')
    }

    this.step4Selectors = {
      emailInput: this.querySelector('.step-4 [name="email"]')
    };

    this.placementCopy = { traditional: '', flexible: '' };
    const placementCopyEl = this.querySelector('[data-placement-copy-json]');
    if (placementCopyEl) {
      try {
        this.placementCopy = JSON.parse(placementCopyEl.textContent);
      } catch (_) {}
    }

    if (this.brandsJson) this.brandsJson = JSON.parse(this.brandsJson.textContent);

    this.currentStep = 1;
    this.breadCrumbProgressEle = this.querySelector('.progress');

    this.userInputs = {};
  }

  static escapePlacementHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  connectedCallback() {
    this.manageStepOne();

    this.initBtn?.forEach(btn => {
      btn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.closest('.speaker-pairings-banner')?.classList.add('d-none');
        this.resetSpeakerPairing();
        this.stepsInit.style.display = 'block';
        this.resultsEle.style.display = 'none';
        this.classList.remove('d-none');
        this.classList.add('d-block');
        let otherSections = this.closest('main').querySelectorAll('.shopify-section:not(.speaker-pairing-main-section)');
        otherSections?.forEach(sec => sec.style.display = 'none');
      })
    });

    this.stepTrigger.forEach(btn => {
      btn.addEventListener('click', this.loadNextStep.bind(this));
    });

    this.resultsEle.addEventListener('click', (e) => {
      const btn = e.target.closest('.placement-tab-btn');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('btn-primary')) return;

      const scrollY = window.scrollY;
      const tabs = btn.closest('.placement-tabs');
      const placement = btn.dataset.placement;
      tabs.querySelectorAll('.placement-tab-btn').forEach(b => {
        b.classList.toggle('btn-primary', b === btn);
        b.classList.toggle('btn-outline-primary', b !== btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-placement-pane]').forEach(pane => {
        pane.hidden = pane.dataset.placementPane !== placement;
      });
      tabs.querySelectorAll('[data-placement-desc]').forEach(desc => {
        desc.hidden = desc.dataset.placementDesc !== placement;
      });

      const restoreScroll = (y) => {
        speakerPairing._scrollWindowInstant(y);
      };

      restoreScroll(scrollY);

      requestAnimationFrame(() => {
        restoreScroll(scrollY);
        requestAnimationFrame(() => {
          restoreScroll(scrollY);
        });
      });
    });
  }

  resetSpeakerPairing() {
    this.querySelectorAll('.step form')?.forEach(form => {
      form.reset();
      this.querySelector('[data-speaker-brand]')?.setAttribute("disabled","");
      const nextBtn = form.querySelector('button.btn:not(.button-main)');
      if (nextBtn) nextBtn.classList.add('disabled');
    });
    let otherSections = this.closest('main').querySelectorAll('.shopify-section:not(.speaker-pairing-main-section)');
    otherSections?.forEach(sec => sec.style.display = '');
  }

  manageStepOne() {
    this.step1Selectors.model.addEventListener('change', (e) => {
      e.preventDefault();
      let html = `
                  <option disabled selected>Select Your Speaker Brand</option>
                  ${
                    this.brandsJson[e.currentTarget.value]
                      ? this.brandsJson[e.currentTarget.value]
                          .map(option => `<option value="${option}">${option.replaceAll('-',' ')}</option>`)
                          .join('')
                      : ''
                  }`;
      this.step1Selectors.brand.innerHTML = html;
      this.step1Selectors.brand.disabled = false;
    });

    this.step1Selectors.brand.addEventListener('change', (e) => {
      e.preventDefault();
      if(e.currentTarget.value != '') {
        this.userInputs['brand'] = this.step1Selectors.model.value;
        this.userInputs['speaker'] = this.step1Selectors.brand.value;
        this.manageStepBtn(true, 2);
        this.manageStepTwo();
      } else {
        this.manageStepBtn(false, 2);
      }
    })
  }

  manageStepTwo() {
    if(this.step2Selectors.preheadingEle) this.step2Selectors.preheadingEle.innerHTML = `${this.userInputs.brand.replaceAll('-',' ')}, ${this.userInputs.speaker.replaceAll('-',' ')}`;
    this.step2Selectors.intendedUse.forEach(radio => {
      radio.addEventListener('change', (e) => {
        e.preventDefault();
        this.userInputs['intended_use'] = e.currentTarget.value;
        this.manageStepBtn(true, 3);
        this.manageStepThree();
      })
    });
  }

  manageStepThree() {
    if(this.step3Selectors.preheadingEle) this.step3Selectors.preheadingEle.innerHTML = `${this.userInputs.brand.replaceAll('-',' ')}, ${this.userInputs.speaker.replaceAll('-',' ')} `;
    if(this.step3Selectors.preheadingEleIntendedUse) this.step3Selectors.preheadingEleIntendedUse.innerHTML = `${this.userInputs.intended_use == 'Home Theatre' ? 'Music & Theater Multipurpose' : this.userInputs.intended_use == 'theatre' ? 'Theater Primary Use' : 'Music Primary Use' }`;
    this.step3Selectors.roomSizeRadio.forEach(radio => {
      radio.addEventListener('change', (e) => {
        e.preventDefault();
        this.userInputs['room_size'] = e.currentTarget.value;
        this.manageStepBtn(true, '4');
        this.manageStepFour();
      })
    });
  }

  manageStepFour() {
    const emailInput = this.step4Selectors?.emailInput;
    if (!emailInput) return;
    const step4Form = emailInput.closest('form');
    const nextBtn = step4Form?.querySelector('button[data-step-trigger="result"]:not(.button-main)');
    const checkStep4Valid = () => {
      const email = emailInput?.value?.trim() || '';
      const emailValid = email === '' || (typeof Utility !== 'undefined' && Utility.validateEmail(email));
      if (nextBtn) {
        nextBtn.disabled = !emailValid;
        nextBtn.classList.toggle('disabled', !emailValid);
      }
    };
    emailInput.addEventListener('input', checkStep4Valid);
    emailInput.addEventListener('change', checkStep4Valid);
    checkStep4Valid();
  }

  manageStepBtn(show,nextStep) {
    if (show) {
      this.querySelector(`[data-step-trigger="${nextStep}"]:not(.button-main)`).disabled = false;
      this.querySelector(`[data-step-trigger="${nextStep}"]:not(.button-main)`).classList.remove('disabled');
    } else {
      this.querySelector(`[data-step-trigger="${nextStep}"]:not(.button-main)`).disabled = true;
      this.querySelector(`[data-step-trigger="${nextStep}"]:not(.button-main)`).classList.add('disabled');
    }
  }

  loadNextStep(e) {
    e?.preventDefault();
    let nextStep = e.currentTarget.dataset.stepTrigger;
    if(nextStep == 'result') {
      this.breadCrumbProgressEle.style.width = '100%';
      this.renderResults(e);
      this.resultsEle.style.display = 'block';
      this.resultsEle.classList.add('loading');
      this.stepsInit.style.display = 'none';
    } else {
      if (nextStep == 1) this.resetSpeakerPairing();
      if (nextStep == 4) {
        this.manageStepFour();
      }
      this.resultsEle.style.display = 'none';
      this.stepsInit.style.display = 'block';
      this.stepEles.forEach(step => step.dataset.step == nextStep ? step.classList.remove('d-none') : step.classList.add('d-none'));
      this.stepEles.forEach(step => step.dataset.step == nextStep ? step.classList.add('active') : step.classList.remove('active'));
      this.stepEles.forEach(step => step.dataset.step == nextStep ? Utility.fadeIn(step,300) : Utility.fadeOut(step,300));
      this.currentStep = parseInt(nextStep);
    }

    switch (this.currentStep) {
      case 1:
        this.breadCrumbProgressEle.style.width = '25%';
        break;
      case 2:
        this.breadCrumbProgressEle.style.width = '50%';
        break;
      case 3:
        if (nextStep === 'result') {
          this.breadCrumbProgressEle.style.width = '100%';
        } else {
          this.breadCrumbProgressEle.style.width = '75%';
        }
        break;
      case 4:
        this.breadCrumbProgressEle.style.width = '90%';
        break;
      default:
        this.breadCrumbProgressEle.style.width = '100%';
        break;
    }
  }

  async renderResults(e) {
    let data = await this.getResults();

    let frontData = {};
    let threeDData = {};

    // Only show results for positions: front, 3D front, 3D center, 3D rear. We recommend quantities 1, 2, 3, and 6 only; never 4 or 5.
    const allowedQuantities = [1, 2, 3, 6];
    const allowedPositions = ['front', '3d front', '3d center', '3d rear'];

    data.metaobjects.edges.forEach((edge) => {
        let handle = edge.node.handle;
        let fields = edge.node.fields;

        let fieldsObject = fields.reduce((acc, field) => {
            acc[field.key] = field.value;
            return acc;
        }, {});

        let position = (fieldsObject.position || '').toLowerCase().trim();
        let qty = parseInt(fieldsObject.quantity, 10);
        if (!allowedQuantities.includes(qty) || !allowedPositions.includes(position)) return;

        if (position === "front") {
          frontData[handle] = fieldsObject;
        } else if (allowedPositions.indexOf(position) >= 1) {
          threeDData[handle] = fieldsObject;
        }
    });
      
    //NOTE:::::: Home Theatre = Music + Theatre.
 let Single2ChannelSubwoofer = Object.fromEntries(Object.entries(frontData).filter(([_, fieldsObject]) =>
      Object.entries(this.userInputs).every(([dataKey, dataValue]) => {
        if (dataKey === 'intended_use' && dataValue == 'Home Theatre' ) dataValue = fieldsObject[dataKey];
        else if( dataKey === 'intended_use' && dataValue?.toLowerCase() == 'theatre' ) return;
         return fieldsObject[dataKey]?.toLowerCase() === dataValue?.toLowerCase() && (fieldsObject.quantity == '1')
      })
    ));
    Single2ChannelSubwoofer = Object.fromEntries(
      Object.entries(Single2ChannelSubwoofer).filter(
        ([, value]) => value.intended_use?.toLowerCase() !== "theatre"
      )
    );


    let StereoPairSubwoofer = Object.fromEntries(Object.entries(frontData).filter(([_, fieldsObject]) =>
      Object.entries(this.userInputs).every(([dataKey, dataValue]) => {
        if (dataKey === 'intended_use' && dataValue == 'Home Theatre' ) dataValue = fieldsObject[dataKey];
        else if( dataKey === 'intended_use' && dataValue?.toLowerCase() == 'theatre' ) return;
        return (fieldsObject[dataKey]?.toLowerCase() === dataValue?.toLowerCase() && (fieldsObject.quantity == '2'));
      })
    ));
    StereoPairSubwoofer = Object.fromEntries(
      Object.entries(StereoPairSubwoofer).filter(
        ([, value]) => value.intended_use?.toLowerCase() !== "theatre"
      )
    );
    
    let LFEChannel = Object.fromEntries(Object.entries(frontData).filter(([_, fieldsObject]) =>
      Object.entries(this.userInputs).every(([dataKey, dataValue]) => {
        if (dataKey === 'intended_use' && dataValue == 'Home Theatre' ) dataValue = fieldsObject[dataKey];
        else if( dataKey === 'intended_use' && dataValue?.toLowerCase() == 'music' ) return;
        return (fieldsObject[dataKey]?.toLowerCase() === dataValue?.toLowerCase() && (fieldsObject.quantity == '1'));
      })
    ));
    LFEChannel = Object.fromEntries(
      Object.entries(LFEChannel).filter(
        ([, value]) => value.intended_use?.toLowerCase() !== "music"
      )
    );

    let LineArray = Object.fromEntries(Object.entries(frontData).filter(([key, fieldsObject]) =>
      Object.entries(this.userInputs).every(([dataKey, dataValue]) => {
        if (dataKey === 'intended_use' && dataValue == 'Home Theatre' )  dataValue = fieldsObject[dataKey];
        else if( dataKey === 'intended_use' && dataValue?.toLowerCase() == 'theatre' ) return;
        return (fieldsObject[dataKey]?.toLowerCase() === dataValue?.toLowerCase() && (fieldsObject.quantity == '6' || fieldsObject.quantity == '3'));
      }) && !LFEChannel.hasOwnProperty(key)
    ));
    LineArray = Object.fromEntries(
      Object.entries(LineArray).filter(
        ([, value]) => value.intended_use?.toLowerCase() !== "theatre"
      )
    );

    const threeDAllowedQuantities = ['1', '2', '3'];
    let filteredThreeDData = Object.fromEntries(Object.entries(threeDData).filter(([_, fieldsObject]) =>
        Object.entries(this.userInputs).every(([dataKey, dataValue]) => {
          if (dataKey === 'intended_use' && dataValue == 'Home Theatre' ) dataValue = fieldsObject[dataKey];
          else if( dataKey === 'intended_use' && dataValue?.toLowerCase() == 'music' ) return;
          return (fieldsObject[dataKey]?.toLowerCase() === dataValue?.toLowerCase() && threeDAllowedQuantities.includes(String(fieldsObject.quantity)));
        })
    ));
    filteredThreeDData = Object.fromEntries(
      Object.entries(filteredThreeDData).filter(
        ([, value]) => value.intended_use?.toLowerCase() !== "music"
      )
    );


    let selectionsHTMl = `<p>You've selected <b class="fw-medium">${this.userInputs.brand.replaceAll('-',' ')}, ${this.userInputs.speaker.replaceAll('-',' ')} </b> speakers for <b class="fw-medium">${this.userInputs.intended_use == 'theatre' ? 'Theater Primary Use' : this.userInputs.intended_use == 'Home Theatre' ? 'Music & Theater Multipurpose' : 'Music Primary Use'}</b> in a <b class="fw-medium">${this.userInputs.room_size} Room</b>.</p>`;
    if(this.querySelector('[data-selection-html]')) this.querySelector('[data-selection-html]').innerHTML = selectionsHTMl;

    let emptyStateEle = this.querySelector('[data-empty-state]');
    let resultsTab = this.querySelector('[data-results-tab]');

    // Check if all tabs are empty
    let allTabsEmpty = Object.keys(filteredThreeDData).length === 0 && 
                      Object.keys(LFEChannel).length === 0 && 
                      Object.keys(LineArray).length === 0 && 
                      Object.keys(Single2ChannelSubwoofer).length === 0 && 
                      Object.keys(StereoPairSubwoofer).length === 0;

    if (allTabsEmpty) {
      emptyStateEle?.classList.remove('d-none');
      resultsTab?.classList.add('d-none');
    } else {
      resultsTab?.classList.remove('d-none');
      emptyStateEle?.classList.add('d-none');

      // Activate the first available tab
      this.activateFirstAvailableTab(LFEChannel, LineArray, Single2ChannelSubwoofer, StereoPairSubwoofer, filteredThreeDData);
    }

    // Handle LFE Channel tab (tab 1)
    let lfeWrapper = this.querySelector('#pairing-tab-LFEChannel .collection-list');
    let lfeTab = this.querySelector('#tab-header-1');
    if (lfeWrapper) {
      if (Object.keys(LFEChannel).length > 0) {
        lfeWrapper.classList.remove('d-none');
        lfeTab.classList.remove('d-none');
        lfeWrapper.innerHTML = this.generateHTML(LFEChannel,lfeTab);
      } else {
        lfeTab.classList.add('d-none');
        lfeWrapper.classList.add('d-none');
      }
    }

    // Handle Line Array tab (tab 2)
    let lineArrayWrapper = this.querySelector('#pairing-tab-LineArray .collection-list');
    let lineArrayTab = this.querySelector('#tab-header-2');
    if (lineArrayWrapper) {
      if (Object.keys(LineArray).length > 0) {
        lineArrayWrapper.classList.remove('d-none');
        lineArrayTab.classList.remove('d-none');
        lineArrayWrapper.innerHTML = this.generateHTML(LineArray,lineArrayTab);
      } else {
        lineArrayTab.classList.add('d-none');
        lineArrayWrapper.classList.add('d-none');
      }
    }

    // Handle Single 2 Channel Subwoofer tab (tab 3)
    let single2ChannelWrapper = this.querySelector('#pairing-tab-Single2ChannelSubwoofer .collection-list');
    let single2ChannelTab = this.querySelector('#tab-header-3');
    if (single2ChannelWrapper) {
      if (Object.keys(Single2ChannelSubwoofer).length > 0) {
        single2ChannelWrapper.classList.remove('d-none');
        single2ChannelTab.classList.remove('d-none');
        single2ChannelWrapper.innerHTML = this.generateHTML(Single2ChannelSubwoofer,single2ChannelTab);
      } else {
        single2ChannelTab.classList.add('d-none');
        single2ChannelWrapper.classList.add('d-none');
      }
    }

    // Handle Stereo Pair Subwoofer tab (tab 4)
    let stereoPairWrapper = this.querySelector('#pairing-tab-StereoPairSubwoofer .collection-list');
    let stereoPairTab = this.querySelector('#tab-header-4');
    if (stereoPairWrapper) {
      if (Object.keys(StereoPairSubwoofer).length > 0) {
        stereoPairWrapper.classList.remove('d-none');
        stereoPairTab.classList.remove('d-none');
        stereoPairWrapper.innerHTML = this.generateHTML(StereoPairSubwoofer,stereoPairTab);
      } else {
        stereoPairTab.classList.add('d-none');
        stereoPairWrapper.classList.add('d-none');
      }
    }

    // Handle REL 3D Subwoofer tab (tab 5)
    let threeDWrapper = this.querySelector('#pairing-tab-filteredThreeDData .collection-list');
    let threeDTab = this.querySelector('#tab-header-5');
    if (threeDWrapper) {
      if (Object.keys(filteredThreeDData).length > 0) {
        threeDWrapper.classList.remove('d-none');
        threeDTab.classList.remove('d-none');
        threeDWrapper.innerHTML = this.generateHTML(filteredThreeDData,threeDTab);
      } else {
        threeDTab.classList.add('d-none');
        threeDWrapper.classList.add('d-none');
      }
    }

    this.resultsEle.classList.remove('loading');

    let otherSections = this.closest('main').querySelectorAll('.shopify-section:not(.speaker-pairing-main-section)');
    otherSections?.forEach(sec => sec.style.display = '');
    let email = this.step4Selectors?.emailInput?.value?.trim() || '';
  try {
    if (email !== '' && e.target.dataset.skip !== "true" && !Utility.validateEmail(email)) {
      window.notificationEle.updateNotification('Input required!', 'Please provide valid email to submit selection.', {
        type: 'error',
        timeout: 5000
      });
      return;
    }

    const extractProducts = (selector) => {
      const items = this.querySelectorAll(`${selector} .collection-box`);
      return Array.from(items).map(item => {
        const title = item.querySelector('h3')?.innerText?.trim() || '';
        const subTitle = item.querySelector('p')?.innerText?.trim() || '';
        const subDesc = item.querySelector('.collection-sub-desc')?.innerText?.trim() || '';
        const imageUrl = item.querySelector('img')?.src || '';
        const productUrl = item.querySelector('a')?.getAttribute('href') || '';
        const price = item.querySelector('.price')?.innerText?.trim() || '';
        const recommendedResultText = item.querySelector('.recommended-result') && item.querySelector('.recommended-result').innerText.trim() !== "" ? "REL ideal setup. Scroll below for more options that meet your needs." : '';
        const hasRecommendedBadge = item.querySelector('.recommended-result') ? true : false;
        const starIconUrl = hasRecommendedBadge ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '';
        const badgeText = item.querySelector('.badge')?.innerText?.trim() || '';
        return {
          title, subTitle, subDesc, imageUrl, productUrl, price, recommendedResultText, starIconUrl, badgeText
        };
      });
    };

    const { list: recommendedPairedSpeakers, handles: recommendedPairedSpeakerHandles, idealHandles: idealRecommendedSpeakerHandles } = this.buildRecommendedPairedSpeakersList(LFEChannel, LineArray, Single2ChannelSubwoofer, StereoPairSubwoofer, filteredThreeDData);

    const eventData = {
      type: "event",
      attributes: {
        metric: {
          data: { type: "metric", attributes: { name: "Speaker Pairing form submitted" } }
        },
        profile: {
          data: {
            type: "profile",
            attributes: { email: email }
          }
        },
        properties: {
          brand: this.userInputs.brand,
          speaker: this.userInputs.speaker,
          intended_use: this.userInputs.intended_use,
          room_size: this.userInputs.room_size,
          first_tab_title: this.querySelector('#tab-header-1 [data-text]')?.innerText ?? '',
          first_tab_star_icon: !this.querySelector('#tab-header-1 .icon-speaker-star')?.classList.contains('d-none') ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '',
          second_tab_title: this.querySelector('#tab-header-2 [data-text]')?.innerText ?? '',
          second_tab_star_icon: !this.querySelector('#tab-header-2 .icon-speaker-star')?.classList.contains('d-none') ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '',
          third_tab_title: this.querySelector('#tab-header-3 [data-text]')?.innerText ?? '',
          third_tab_star_icon: !this.querySelector('#tab-header-3 .icon-speaker-star')?.classList.contains('d-none') ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '',
          fourth_tab_title: this.querySelector('#tab-header-4 [data-text]')?.innerText ?? '',
          fourth_tab_star_icon: !this.querySelector('#tab-header-4 .icon-speaker-star')?.classList.contains('d-none') ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '',
          fifth_tab_title: this.querySelector('#tab-header-5 [data-text]')?.innerText ?? '',
          fifth_tab_star_icon: !this.querySelector('#tab-header-5 .icon-speaker-star')?.classList.contains('d-none') ? 'https://cdn.shopify.com/s/files/1/0702/9293/0776/files/STAR.svg?v=1762255696' : '',
          lfeData: extractProducts('#pairing-tab-LFEChannel'),
          lineArrayData: extractProducts('#pairing-tab-LineArray'),
          twoChannelData: extractProducts('#pairing-tab-Single2ChannelSubwoofer'),
          stereoPairData: extractProducts('#pairing-tab-StereoPairSubwoofer'),
          filteredThreeDData: extractProducts('#pairing-tab-filteredThreeDData'),
          recommended_paired_speakers: recommendedPairedSpeakers,
          recommended_paired_speaker_handles: recommendedPairedSpeakerHandles,
          ideal_recommended_speaker_handles: idealRecommendedSpeakerHandles,
        }
      }
    };

    if (email !== '') {
      try {
        await this._registerKlaviyoEvt(eventData);
        await this._subscribeToKlaviyo(email);
      } catch (error) {
        console.error('Klaviyo event error:', error);
      }
    }
  } catch (error) {
    console.log("Error in submitting Klaviyo event:", error);
  }
    
  }

  activateFirstAvailableTab(LFEChannel, LineArray, Single2ChannelSubwoofer, StereoPairSubwoofer, filteredThreeDData) {
    // Define tab data in order of priority
    const tabData = [
      { data: LFEChannel, tabId: 'tab-header-1', contentId: 'pairing-tab-LFEChannel' },
      { data: LineArray, tabId: 'tab-header-2', contentId: 'pairing-tab-LineArray' },
      { data: Single2ChannelSubwoofer, tabId: 'tab-header-3', contentId: 'pairing-tab-Single2ChannelSubwoofer' },
      { data: StereoPairSubwoofer, tabId: 'tab-header-4', contentId: 'pairing-tab-StereoPairSubwoofer' },
      { data: filteredThreeDData, tabId: 'tab-header-5', contentId: 'pairing-tab-filteredThreeDData' }
    ];

    // Find the first tab with content
    const firstAvailableTab = tabData.find(tab => Object.keys(tab.data).length > 0);
    
    if (firstAvailableTab) {
      // Remove open class from all tabs
      document.querySelectorAll('.tablink').forEach(tab => {
        tab.classList.remove('open','show');
      });
      document.querySelectorAll('.tabcontent').forEach(pane => {
        pane.classList.remove('open','show');
      });

      // Activate the first available tab
      const tabElement = this.querySelector(`#${firstAvailableTab.tabId}`);
      const contentElement = this.querySelector(`#${firstAvailableTab.contentId}`);
      
      if (tabElement && contentElement) {
        tabElement.classList.add('open', 'show');
        contentElement.classList.add('open', 'show');
      }
    }
  }

  changeTabTitle(data) {
    let title = '';
    let variantTitle = '';
    for (let item of Object.values(data)) {
      let intendedUse = item.intended_use.toLowerCase();
      let quantity = parseInt(item.quantity, 10);
  
      if (intendedUse === "music" && quantity === 1 && item.position.indexOf('3D') === -1) {
        title = 'Single 2-Channel Subwoofer';
        variantTitle = 'Single Subwoofer'
      } else if (quantity === 2 && item.position.indexOf('3D') === -1) {
        title = 'Stereo Pair Subwoofer';
        variantTitle = 'Stereo Pair'
      } else if (intendedUse === "theater" && quantity === 1 && item.position.indexOf('3D') === -1) {
        title = 'LFE/.1 Channel';
        variantTitle = ''
      } else if (quantity === 3 && item.position.indexOf('3D') === -1) {
        title = 'Line Array';
        variantTitle = 'Line Array'
      } else {
        title = 'REL 3D Subwoofer';
        if (quantity === 2) {
          variantTitle = 'Stereo Pair'
        } else if (quantity === 3) {
          variantTitle = 'Line Array'
        } else if(quantity === 1) {
          variantTitle = 'Single Subwoofer'
        } else {
          variantTitle = ''
        }
      }
      
      break;
    }
    return {title,variantTitle};
  }

  generateHTML = (filteredData, tabElement) => {
    let { title } = this.changeTabTitle(filteredData);

    let article = this.tabArticles;
    let requriedIndex = 0;
    let requiredArticle = null;

    if (title === 'Single 2-Channel Subwoofer') {
      requiredArticle = article?.['two_single_channel_article'];
    } else if (title === 'REL 3D Subwoofer') {
      requiredArticle = article?.['subwoofer_article'];
      requriedIndex = 1;
    } else if (title === 'Stereo Pair Subwoofer') {
      requiredArticle = article?.['sterio_article'];
    }

    let articleHTML = '';
    if (requiredArticle && typeof requiredArticle === 'object' && requiredArticle.url) {
      let filteredTags = requiredArticle.tags.filter(item => item.includes('cat_primary_'));
      articleHTML = `
        <a href="${requiredArticle.url}" class="article-card border mt-5 d-flex flex-column flex-lg-row rounded overflow-hidden border-gray-100 d-none">
          <div class="card-img p-0 overflow-hidden">
            ${requiredArticle.image
              ? `<img src="${requiredArticle.image}" class="w-100 object-fit-cover" width="280" height="185" loading="lazy" alt="${requiredArticle.title || 'Article Image'}">`
              : ''}
          </div>
          <div class="card-text p-3 flex-fill">
            <div class="p-1">
              ${filteredTags[0] ? `<span class="subheading mb-2 d-block text-secondary-1">${filteredTags[0].replace('cat_primary_', '')}</span>` : ''}
              <h4 class="h5">${requiredArticle.title || 'Untitled Article'}</h4>
            </div>
          </div>
        </a>`;
    }

    const items = Object.values(filteredData);
    const hasSecondary = items.some(item => item.secondary_product);

    const primaryHTML = items.map((item, index) => {
      return this._buildCard(item, index, item.product, tabElement, requriedIndex === index ? articleHTML : '', true);
    }).join('');

    if (!hasSecondary) return primaryHTML;

    const secondaryHTML = items.map((item, index) => {
      if (!item.secondary_product) return '';
      return this._buildCard(item, index, item.secondary_product, tabElement, '', false);
    }).join('');

    const traditionalDesc = speakerPairing.escapePlacementHtml(this.placementCopy.traditional || '');
    const flexibleDesc = speakerPairing.escapePlacementHtml(this.placementCopy.flexible || '');

    return `<div class="placement-tabs">
      <div class="placement-segmented" role="tablist" aria-label="Placement type">
        <button type="button" role="tab" aria-selected="true" class="placement-segmented__btn btn btn-primary overflow-hidden placement-tab-btn" data-placement="traditional">Traditional Placement</button>
        <button type="button" role="tab" aria-selected="false" class="placement-segmented__btn btn btn-outline-primary overflow-hidden placement-tab-btn" data-placement="flexible">Flexible Wall Placement</button>
      </div>
      <div class="placement-tabs__descriptions px-2 px-md-3">
        <p class="placement-tabs__hint text-center text-secondary-2 fs-sm mb-0 mt-3 mx-auto" data-placement-desc="traditional">${traditionalDesc}</p>
        <p class="placement-tabs__hint text-center text-secondary-2 fs-sm mb-0 mt-3 mx-auto" data-placement-desc="flexible" hidden>${flexibleDesc}</p>
      </div>
      <div data-placement-pane="traditional">${primaryHTML}</div>
      <div data-placement-pane="flexible" hidden>${secondaryHTML}</div>
    </div>`;
  };

  _buildCard(item, index, productGid, tabElement, articleHTMLString, isPrimary) {
    if (!productGid) return '';

    let variantTitle = '';
    if (item.quantity == 2) variantTitle = 'Stereo Pair';
    else if (item.quantity == 3) variantTitle = 'Line Array';
    else if (item.quantity == 1) variantTitle = 'Single Subwoofer';

    let productID = productGid.split('/').pop();
    let product = this.allProducts[productID];
    if (!product) {
      console.warn(`Product not found for ID: ${productID}`);
      return '';
    }

    let variantData = null;
    if (product.variants && Array.isArray(product.variants)) {
      variantData = product.variants.find(v =>
        (v.option1 && v.option1?.toLowerCase().replaceAll(/\s+/g, '-') === variantTitle.toLowerCase().replaceAll(/\s+/g, '-')) ||
        (v.option2 && v.option2?.toLowerCase().replaceAll(/\s+/g, '-') === variantTitle.toLowerCase().replaceAll(/\s+/g, '-')) ||
        (v.option3 && v.option3?.toLowerCase().replaceAll(/\s+/g, '-') === variantTitle.toLowerCase().replaceAll(/\s+/g, '-'))
      );
    }

    let productSubDesc = product?.metafields?.section?.sub_description?.value || null;
    let productComparisonRecommendedValue = product?.metafields?.section?.speaker_pairing_recommendation_text?.value || '';
    let render_postions = item.position.includes('3D') || item.display_label_on_results == true;

    if (isPrimary && (item.recommended_result == true || item.recommended_result == 'true')) {
      tabElement.querySelector('.icon-speaker-star')?.classList.remove('d-none');
    }

    return `
      <div class="collection-box">
        ${isPrimary && item.recommended_result ? `<div class="recommended-result text-center py-2 py-lg-4 font-family-heading">
          <span class="fs-14 text-primary d-flex align-items-center justify-content-center"><span class="me-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M14.6602 8.97168L14.7773 9.22559L15.0557 9.25879L21.3652 10.0078L16.7002 14.3291L16.4951 14.5186L16.5498 14.793L17.7871 21.0332L12.2441 17.9268L12 17.7891L11.7559 17.9268L6.21191 21.0332L7.4502 14.793L7.50488 14.5186L7.2998 14.3291L2.63379 10.0078L8.94434 9.25879L9.22266 9.22559L9.33984 8.97168L12 3.19434L14.6602 8.97168Z" fill="url(#paint0_linear_12020_1101__${index})" stroke="#EDD295"/>
            <defs>
            <linearGradient id="paint0_linear_12020_1101__${index}" x1="16.725" y1="20.9474" x2="4.60928" y2="3.6074" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FBE5B4"/>
            <stop offset="0.215" stop-color="#D89B15"/>
            <stop offset="0.58" stop-color="#FFEFCE"/>
            <stop offset="0.915" stop-color="#F2A600"/>
            </linearGradient>
            </defs>
          </svg></span>REL ideal setup. See other tabs for options that meet your needs. </span>
        </div>` : ''}
        <div class="collection-card flex-column flex-md-row section-spacing-top-sm d-flex section-spacing-bottom-sm border-bottom border-gray-100">
          <div class="collection-img aspect-ratio-1">
            <img src="${variantData?.featured_image ? variantData.featured_image.src : (product.featured_image || '')}" alt="${product.title || 'Product'}" class="w-100 h-100 object-fit-contain" loading="lazy">
          </div>
          <div class="collection-text flex-fill">
            <div>
              <div class="mb-2 d-flex align-items-center">
                <h3 class="h2 mb-02 pb-2 me-1">${product.title}</h3>
                ${render_postions ? `<span class="badge rounded-pill bg-gray-100 ms-3 text-primary">${item.position}</span>` : ''}
              </div>
              ${product.description ? `<div class="mb-4">${product.description}</div>` : ''}
              ${productSubDesc ? `<div class="img-recom-text mb-4">Why We Recommend the ${product.title} for Your Setup</div><div class="mb-4 collection-sub-desc">${productSubDesc}</div>` : ''}
              ${productComparisonRecommendedValue ? `<div class="mb-4 metafield-content">${productComparisonRecommendedValue}</div>` : ''}
              <div class="d-flex flex-column flex-lg-row gap-2" style="gap: 10px;">
                <a href="/products/${product.handle}${variantData ? `?variant=${variantData.id} ` : ''}" class="btn btn-primary overflow-hidden">Shop Now</a>
                <a class="btn overflow-hidden mt-02 mt-lg-0 btn-outline-primary" onclick="setCompartisionChartProducts(event, '${product.handle}')">Compare More RELs</a>
              </div>
            </div>
            ${articleHTMLString}
          </div>
        </div>
      </div>`;
  }
  
  async getResults() {
    
    let body = {"display_name": this.userInputs.speaker}
    try {
      const response = await fetch('/apps/middleware-data/data', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  }

  /**
   * Builds a flat list of recommended paired speakers from the five result buckets
   * for Klaviyo segment use. Returns { list, handles, idealHandles }.
   */
  buildRecommendedPairedSpeakersList(LFEChannel, LineArray, Single2ChannelSubwoofer, StereoPairSubwoofer, filteredThreeDData) {
    const tabLabels = [
      'LFE Channel',
      'Line Array',
      'Single 2-Channel Subwoofer',
      'Stereo Pair Subwoofer',
      'REL 3D Subwoofer'
    ];
    const buckets = [
      LFEChannel,
      LineArray,
      Single2ChannelSubwoofer,
      StereoPairSubwoofer,
      filteredThreeDData
    ];
    const list = [];
    for (let i = 0; i < buckets.length; i++) {
      const bucket = buckets[i];
      const tabCategory = tabLabels[i];
      if (!bucket || typeof bucket !== 'object') continue;
      for (const item of Object.values(bucket)) {
        const productID = item.product && String(item.product).split('/').pop();
        if (!productID) continue;
        const product = this.allProducts[productID];
        if (!product) {
          console.warn(`Product not found for ID: ${productID}`);
          continue;
        }
        const isIdeal = item.recommended_result === true || item.recommended_result === 'true';
        list.push({
          handle: product.handle,
          title: product.title,
          productId: productID,
          tabCategory,
          isIdeal
        });
      }
    }
    const handles = list.map((entry) => entry.handle);
    const idealHandles = list.filter((entry) => entry.isIdeal).map((entry) => entry.handle);
    return { list, handles, idealHandles };
  }

  async _registerKlaviyoEvt(eventData) {
    try {
      const response = await fetch("https://a.klaviyo.com/client/events/?company_id=JVhXmT", {
        method: "POST",
        headers: {
          "revision": "2024-05-15",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ data: eventData })
      });
  

  
    } catch (error) {
      console.error("Client event error:", error);
      return { success: false, error: error.message };
    }
  }

  /**
   * Subscribe the profile to email marketing in Klaviyo (sets consent to SUBSCRIBED).
   * Uses the Create Client Subscription endpoint for client-side consent.
   */
  async _subscribeToKlaviyo(email) {
    if (!email || !email.trim()) return;
    try {
      const subscriptionData = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Speaker Pairing Tool",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email.trim()
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "YeFs2q"
              }
            }
          }
        }
      };
      await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=JVhXmT", {
        method: "POST",
        headers: {
          "revision": "2024-05-15",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(subscriptionData)
      });
    } catch (error) {
      console.error("Klaviyo subscription error:", error);
    }
  }
  
  
  
  
}


const setCompartisionChartProducts = (e, productHandle) => {
    e.preventDefault();
    
    let products = [];
    const allProducts = document.querySelector('[data-all-products-json]')?.textContent;
    
    if (allProducts) {
        try {
            const productsData = JSON.parse(allProducts);
            const currentProduct = Object.values(productsData).find(p => p.handle === productHandle);
            
            if (currentProduct?.metafields?.section?.product_comparison?.value) {
                products = currentProduct.metafields.section.product_comparison.value;
            }
        } catch (error) {
            console.error('Error parsing products data:', error);
        }
    }
    
    // Process products based on their type
    if (typeof products === 'string') {
        products = products.split(',').map(s => s.trim()).filter(Boolean);
    } else if (Array.isArray(products)) {
        products = products.map(product => {
            if (typeof product === 'string') {
                return product.trim();
            } else if (product && typeof product === 'object') {
                return product.handle || product.id || product.slug || product.title;
            }
            return null;
        }).filter(Boolean);
    } else {
        products = [];
    }
    
    const currentHandle = productHandle;
    
    // Add current product if not already in the list
    if (!products.includes(currentHandle)) {
        if (products.length > 1) {
            products.splice(1, 0, currentHandle);
        } else {
            products.push(currentHandle);
        }
    }
    
    localStorage.setItem('_comparision_chart_products', products.join(','));
    localStorage.setItem('_comparision_chart_product_current', currentHandle);
  
    window.open('/pages/product-comparison', '_blank');
};

customElements.define('speaker-pairing', speakerPairing);